function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscountPrice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D527C"
    },
    d: "M311.301,278.37c-22.542,0-34.955,11.31-34.955,31.846v29.431c0,20.537,12.415,31.847,34.955,31.847 c22.216,0,34.956-11.608,34.956-31.847v-29.431C346.259,289.978,333.517,278.37,311.301,278.37z M305.012,310.216 c0-4.434,1.705-6.083,6.289-6.083c5.392,0,6.498,2.431,6.498,6.083v29.431c0,3.651-1.106,6.083-6.498,6.083 c-4.584,0-6.289-1.648-6.289-6.083V310.216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D527C"
    },
    d: "M291.131,203.133c-5.461,0-10.023,2.767-12.182,7.356l-72.732,149.402 c-0.932,1.864-1.445,3.877-1.445,5.665c0,7.173,6.218,14.851,15.472,14.851c5.605,0,10.762-2.979,12.802-7.353l72.941-149.405 c1.023-2.047,1.237-4.21,1.237-5.667C307.224,209.1,298.903,203.133,291.131,203.133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D527C"
    },
    d: "M200.694,211.631c-22.542,0-34.956,11.31-34.956,31.847v29.431 c0,20.536,12.415,31.846,34.956,31.846c22.214,0,34.956-11.608,34.956-31.846v-29.431 C235.649,223.237,222.909,211.631,200.694,211.631z M194.404,243.476c0-4.434,1.705-6.083,6.291-6.083 c5.392,0,6.498,2.431,6.498,6.083v29.431c0,3.651-1.104,6.083-6.498,6.083c-4.586,0-6.291-1.648-6.291-6.083V243.476z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 82.732,
    y: 14.609,
    style: {
      fill: "#CEE8FA"
    },
    width: 346.538,
    height: 122.32
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D527C"
    },
    d: "M429.265,0H82.73c-8.068,0-14.609,6.54-14.609,14.609v482.782c0,8.069,6.54,14.609,14.609,14.609 h13.179c4.076,0,7.966-1.703,10.732-4.697l33.846-36.645l33.847,36.645c2.879,3.118,6.8,4.697,10.735,4.697 c3.546,0,7.098-1.283,9.909-3.877c5.927-5.474,6.294-14.717,0.82-20.644l-44.579-48.263c-2.765-2.993-6.656-4.697-10.732-4.697 c-4.076,0-7.966,1.703-10.732,4.697L97.341,474.31V151.544h317.317V474.31l-32.414-35.095c-2.765-2.993-6.656-4.697-10.732-4.697 c-4.076,0-7.966,1.703-10.732,4.697l-40.24,43.567h-13.567l-40.24-43.567c-5.473-5.925-14.716-6.292-20.644-0.82 c-5.927,5.475-6.294,14.717-0.82,20.644l44.579,48.263c2.765,2.993,6.656,4.697,10.732,4.697h26.354 c4.076,0,7.966-1.703,10.732-4.697l33.847-36.645l33.846,36.645c2.765,2.993,6.656,4.697,10.732,4.697h13.179 c8.069,0,14.609-6.54,14.609-14.609V14.609C443.874,6.54,437.334,0,429.265,0z M97.339,122.326V29.218h317.317v93.108H97.339z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountPrice);
export default __webpack_public_path__ + "static/media/discount-price.b9625a981739ec682eeec528c688a684.svg";
export { ForwardRef as ReactComponent };